<template>
  <div class="research-report">
    <sn-header text="逐月匹配研报数量" @change="onToggleStatusChange"></sn-header>
    <el-collapse-transition>
      <div class="conditions" v-if="conditionsShow">
        <bar-chart :data="researchReportNumber" v-if="researchReportNumber"></bar-chart>
      </div>
    </el-collapse-transition>
  </div>
</template>
<script>
import SnHeader from '@/components/common/SnHeader';
import BarChart from '@/components/common/BarChart';
import QuestionQuery from '@/rest/questionQuery';

export default {
  data() {
    return {
      conditionsShow: true,
      researchReportNumber: null
    };
  },
  methods: {
    onToggleStatusChange(res) {
      this.conditionsShow = res;
    },
    getResearchReportNumber() {
      QuestionQuery.getResearchReportNumber().then(res => {
        this.researchReportNumber = res;
      });
    }
  },
  components: {
    SnHeader,
    BarChart
  },
  mounted() {
    this.getResearchReportNumber();
  }
};
</script>
<style lang="scss" scoped>
.research-report {
  .conditions {
    padding: 16px;
    background-color: #ffffff;
  }
}
</style>
